import { ReadonlyURLSearchParams } from 'next/navigation';

export const getInstantConfirmation = (searchParams: ReadonlyURLSearchParams) =>
  !!searchParams.get('instantConfirmation');
